export var ETransportType = /*#__PURE__*/function (ETransportType) {
  ETransportType["Transport"] = "transport";
  ETransportType["Walk"] = "walk";
  return ETransportType;
}({});